import React, { useState, useEffect } from "react";

export default function LoadingBar({ show }) {
  const [displayText, setDisplayText] = useState("");
  const companyName = localStorage.getItem('company_nm')?.trim() || "MES";
  const deviceType = localStorage.getItem('deviceType') || "";
  const fontSize = deviceType === "M" 
    ? "9vw" 
    : deviceType === "T" 
      ? "7vw" 
      : "4vw";
  const letterSpacing = deviceType === "M"
  ? "4px"
  : deviceType === "T"
    ? "6px"
    : "8px";


  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      setDisplayText(companyName.substring(0, (i % (companyName.length + 1))));
      i++;
    }, 300);
    return () => clearInterval(interval);
  }, []);

  if (!show) return null;

  return (
    <>
      <style>{`
        .loading-overlay {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
          position: fixed;
          width: 100%;
          top: 0;
          left: 0;
          z-index: 9999;
          background: rgba(255,255,255,0.4);
          backdrop-filter: blur(6px);
        }
        .loading-text {
          font-size: ${fontSize};
          letter-spacing: ${letterSpacing};
          font-weight: 900;
          background: linear-gradient(
            270deg,              /* 🔄 오른쪽 → 왼쪽 */
            #3D63AE 0%,
            #6EA8FE 40%,
            #ffffff 47%,         /* 🎯 하이라이트 좁게 */
            #6EA8FE 54%,
            #3D63AE 100%
          );
          background-size: 200% auto;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          animation: shimmer 2.5s linear infinite;
        }
        @keyframes shimmer {
          0% {
            background-position: 200% center;
          }
          100% {
            background-position: -200% center;
          }
        }
      `}</style>

      <div className="loading-overlay">
        <span className="loading-text">{companyName}</span>
      </div>
    </>
  );
}
